<template>
   <div>
    {{ igins }}
   </div>
</template>
  
  <script>
   import axios from 'axios';

   import authService from '@/auth.service';

  
  export default {

    data () {
        return {
          access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
          igins:[],
    
        }
      
        

    },
    mounted() {
      this.loadGin();
    },
    methods : {
      async loadGin() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/igrn/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igins = data;
     
      
    } catch (error) {
      console.log(error.response);
    }
  },
    }
 


   
    
  };
  </script>
  
  <style>
body, html, #app, #dayspan {
    font-family: Roboto, sans-serif;
    width: 100%;
    height: 100%;
}
.vueconf {
  background-color: #00a65a !important;
}
  </style>
  